import PraveenDeorani from "../Assets/PraveenDeorani.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={PraveenDeorani}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Praveen Deorani</h2>
        <br />
        <p className="card-sub-name-style">
          Deputy Director, MOH Office for Healthcare Transformation
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />

            <h2>Praveen Deorani</h2>
            <br />
            <h3>Deputy Director, MOH Office for Healthcare Transformation</h3>
            <br />
            <p>
              Praveen Deorani is a Principal Data Scientist at the MOH Office of
              Healthcare Transformation, where he applies advanced analytics and
              modeling to inform programs and uncover system-level patterns in
              Singapore’s public healthcare system. His work focuses on
              value-driven care, healthcare delivery, clinical trial design, and
              digital behavior change. He earned his Ph.D. from the National
              University of Singapore in 2015.
              <br />
              <br />
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
